module.exports = __webpack_public_path__ + "img/2.702e8da0.png";